import React from 'react';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import OptionCheckbox from './OptionCheckbox';

const SimpleOptionImageDetailsLayer = ({
  option,
  analyticsKey,
  analyticsKey2,
  onDetails
}) => {
  const { smallImageUrl, showDetailsLayer, description } = option;

  if (!smallImageUrl || !showDetailsLayer) {
    return null;
  }

  return (
    <button
      className="simple-option__image-column simple-option__image-column--selectable stat-image-link"
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}
      onClick={() => onDetails(option)}>
      <img
        className="simple-option__image"
        src={smallImageUrl}
        alt={description}
      />
      <SvgIcon name="info" className="simple-option__info-icon--contained" />
    </button>
  );
};

const SimpleOptionInfoOnlyDetailsLayer = ({
  option,
  analyticsKey,
  analyticsKey2,
  onDetails
}) => {
  const { smallImageUrl, showDetailsLayer } = option;

  if (smallImageUrl || !showDetailsLayer) {
    return null;
  }

  return (
    <button
      className="simple-option__image-column simple-option__image-column--selectable simple-option__image-column--bottom stat-image-link"
      data-dtm={analyticsKey}
      data-dtm2={analyticsKey2}
      onClick={() => onDetails(option)}>
      <SvgIcon name="info" />
    </button>
  );
};

const SimpleOptionImageOnlyDetailsLayer = ({ option }) => {
  const { smallImageUrl, showDetailsLayer, description } = option;

  if (!smallImageUrl || showDetailsLayer) {
    return null;
  }

  return (
    <div className="simple-option__image-column">
      <img
        src={smallImageUrl}
        alt={description}
        className="simple-option__image"
      />
    </div>
  );
};

const SimpleOptionPrice = ({ option, hidePrice }) => {
  const { requiresPackage, includedInPackage, displayedMsrp } = option;

  if (hidePrice) {
    return null;
  }
  if (requiresPackage) {
    return <Translate value="component.pricing.package.requires" />;
  }
  if (includedInPackage) {
    return <Translate value="component.pricing.package.includes" />;
  }
  // TODO: This needs to be handled on the api so it returns an empty string, for now we hack around it :(
  if (displayedMsrp && displayedMsrp !== '$0' && displayedMsrp !== '0 $') {
    return displayedMsrp;
  }
  return null;
};

const SimpleOption = ({
  option,
  disabled,
  hidePrice,
  analyticsKey,
  analyticsKey2,
  onChange,
  onDetails
}) => {
  const onLabelClick = () => {
    if (!disabled) {
      onChange(option);
    }
  };

  return (
    <div className="option simple-option">
      <div className="option__row">
        <div>
          <OptionCheckbox
            id={option.id}
            checked={option.selected}
            conflict={option.conflict}
            disabled={disabled}
            analyticsKey={analyticsKey}
            analyticsKey2={analyticsKey2}
            onChange={() => onChange(option)}
          />
        </div>
        <div className="option__column simple-option__content">
          <div
            className={`option__selectable simple-option__description stat-checkbox ${
              disabled ? 'option__selectable--disabled' : ''
            }`}
            dangerouslySetInnerHTML={{ __html: option.description }}
            data-dtm={analyticsKey}
            data-dtm2={analyticsKey2}
            onClick={onLabelClick}
          />
          <div className="price option__price">
            <SimpleOptionPrice option={option} hidePrice={hidePrice} />
          </div>
        </div>
        <SimpleOptionImageDetailsLayer
          option={option}
          analyticsKey={analyticsKey}
          analyticsKey2={analyticsKey2}
          onDetails={onDetails}
        />
        <SimpleOptionInfoOnlyDetailsLayer
          option={option}
          analyticsKey={analyticsKey}
          analyticsKey2={analyticsKey2}
          onDetails={onDetails}
        />
        <SimpleOptionImageOnlyDetailsLayer option={option} />
      </div>
    </div>
  );
};

export default SimpleOption;
